import React, { Component } from "react";
import { withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch" 
import {getMessagemErro} from "../../utils/erro";
import api from "../../services/api";
import './Organization.css';
import { isCNPJ } from '../../utils/cnpjValidation';
import { maskedCnpjInput } from '../../utils/maskUtil';

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

export const OrganizationEdit =

withRouter(

// redux
connect(
	null, 
	(mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				orgao: {
					id: undefined,
					nome: "",
					sigla: "",
					cnpj: "",
					vinculadoSiape: true,
					nomeRepresentanteNegocial: "",
					emailRepresentanteNegocial: "",
					nomeRepresentanteTecnico: "",
					emailRepresentanteTecnico: "",
					isAdministrador : false,
					naturezaJuridica: undefined,
					nomeNaturezaJuridica: "",
					esferaAdministrativa: "",
					codigoMunicipioIBGE: "",
					nomeMunicipioIBGE: "",
					uf: "",
				},
				naturezasJuridicas: [],
				hasEsferaAdministrativa: true,
				executouPesquisaCNPJ: false,
				botoesHabilitados : true,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.salvar = this.salvar.bind(this);
			this.novo = this.novo.bind(this);
			this.pesquisarDadosEmpresariaisBasicos = this.pesquisarDadosEmpresariaisBasicos.bind(this);
			this.atualizaOrgao = this.atualizaOrgao.bind(this);
			this.getCodigoIBGE = this.getCodigoIBGE.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
						<Message />
						<Loading />
						
						<div  style={{margin: "10px"}}>
							<h1>Cadastro de Órgãos</h1>
						</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;
			api.get('/api/natureza-juridica')
			.then(response => { 
				const naturezasJuridicas = response.data;
				this.setState(
					{
						naturezasJuridicas,
					}, () => {
						if (id) {
							api.get('/api/orgao/' + id)
								.then(response => { 
									const orgao = response.data;
									this.setState(
										{
											orgao,
											executouPesquisaCNPJ: true
										}, () => {
											this.checkEsferaAdministrativa()
									}) 
								})
								.catch(erro => {
									console.log("Não foi possível recuperar órgão " + erro)
									this.props.exibeMensagemErro("Erro durante o carregamento da página")
								});
							
						}
					}) 
			})
			.catch(erro => {
				console.log("Não foi possível recuperar as naturezas jurídicas " + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});
	
		}

		renderForm() {
			const executouPesquisaCNPJ = this.state.executouPesquisaCNPJ;

			return(
				<div className="container-fluid">
					<div className="br-form">

						<div className="row">

							<div className="col-sm-2 mr-1 pr-1">
								<div className="field">
									<div className="input">
										<label htmlFor="cnpj">CNPJ:</label>
										<input type="text" name="cnpj" maxLength="18"
											value={maskedCnpjInput(this.state.orgao.cnpj)}  
											onChange={(e) => {
												e.target.value = e.target.value.replace(/[.\-/]/g, "");
												this.handleInputChange(e);
											}}
											disabled={this.state.orgao.id ? true : false}
											/>
									</div>
								</div>
							</div>

							<div className="d-flex align-items-end ml-0 pl-0">
								<div className="actions-button">
									<div className="actions">
										<div>
											<button type="button" className="button is-secondary" onClick={this.pesquisarDadosEmpresariaisBasicos}>Pesquisar Órgão</button>
										</div>
									</div>
								</div>
							</div>

							{(executouPesquisaCNPJ) &&
								<div className="col-sm-2">
									<div className="field">
										<div className="input">
											<label htmlFor="consumidora">Vinculado ao Siape:</label>
											<SelectSearch
												id="vinculadoSiape"
												name="vinculadoSiape"
												options={[{ value: true, label: 'Sim' }, { value: false, label: 'Não' }]}
												onChange={this.handleInputChange}
												value={this.state.orgao.vinculadoSiape}
											/>
										</div>
									</div>
								</div>
							}	
						</div>

						{(executouPesquisaCNPJ) &&
							<>
								<div className="row">

									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="esferaAdministrativa">Esfera Administrativa:</label>
												<SelectSearch
													id="esferaAdministrativa"
													name="esferaAdministrativa"
													options={[{ value: "F", label: 'Federal' }, { value: "E", label: 'Estadual' }, { value: "M", label: 'Municipal' }]}
													onChange={this.handleInputChange}
													value={this.state.orgao.esferaAdministrativa}
													disabled={this.state.hasEsferaAdministrativa ? true : false}
												/>
											</div>
										</div>
									</div>

									<div className="col-md-6">
										<div className="field">
											<div className="input">
												<label htmlFor="nomeNaturezaJuridica">Natureza Jurídica:</label>
												<input type="text" name="nomeNaturezaJuridica"
													value={this.state.orgao.nomeNaturezaJuridica}
													disabled={true}
													/>
											</div>
										</div>
									</div>

									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="uf">Unidade da Federação:</label>
												<input type="text" name="uf" 
													value={this.state.orgao.uf}
													disabled={true}
													/>
											</div>
										</div>
									</div>
								</div>

								{ (this.state.orgao.esferaAdministrativa === 'E' || this.state.orgao.esferaAdministrativa === 'M') &&
									<>
										<div className="row">
											{ this.state.orgao.esferaAdministrativa === 'M' &&
												<div className="col-md">
													<div className="field">
														<div className="input">
															<label htmlFor="nomeMunicipioIBGE">Município:</label>
															<input type="text" name="nomeMunicipioIBGE" 
																value={this.state.orgao.nomeMunicipioIBGE}
																disabled={true}
																/>
														</div>
													</div>
												</div>
											}
											<div className="col-sd">
												<div className="field">
													<div className="input">
														<label htmlFor="codigoMunicipioIBGE">Código IBGE:</label>
														<input type="text" name="codigoMunicipioIBGE" 
															value={this.getCodigoIBGE(this.state.orgao.codigoMunicipioIBGE)}
															disabled={true}
															/>
													</div>
												</div>
											</div>
										</div>
									</>
								}

								<div className="row">
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="nome">Nome:</label>
												<input type="text" name="nome" 
													value={this.state.orgao.nome}  
													onChange={this.handleInputChange} 
													maxLength="100"/>
											</div>
										</div>
									</div>

									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="sigla">Sigla:</label>
												<input type="text" name="sigla" 
													value={this.state.orgao.sigla}  
													onChange={this.handleInputChange} 
													maxLength="50"/>
											</div>
										</div>
									</div>
								</div>

								<div className="row">
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="representanteNegocial">Nome Representante Negocial:</label>
												<input type="text" name="nomeRepresentanteNegocial" 
													value={this.state.orgao.nomeRepresentanteNegocial}  
													onChange={this.handleInputChange} 
													maxLength="40"/>
											</div>
										</div>
									</div>

									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="emailRepresentanteNegocial">Email Representante Negocial:</label>
												<input type="text" name="emailRepresentanteNegocial" 
													value={this.state.orgao.emailRepresentanteNegocial}  
													onChange={this.handleInputChange} 
													maxLength="60"/>
											</div>
										</div>
									</div>	
								</div>

								<div className="row">
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="representanteTecnico">Nome Representante Técnico:</label>
												<input type="text" name="nomeRepresentanteTecnico" 
													value={this.state.orgao.nomeRepresentanteTecnico}  
													onChange={this.handleInputChange} 
													maxLength="40"/>
											</div>
										</div>
									</div>

									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="emailRepresentanteTecnico">Email Representante Técnico:</label>
												<input type="text" name="emailRepresentanteTecnico" 
													value={this.state.orgao.emailRepresentanteTecnico}  
													onChange={this.handleInputChange} 
													maxLength="60"/>
											</div>
										</div>
									</div>	
								</div>
							</>	
						}

						{/* button actions */}
						<div className="actions-button">
							<div className="actions justify-content-start">
								{(this.state.executouPesquisaCNPJ) &&
									<button type="button" className="button is-primary" onClick={this.salvar} disabled={!this.state.botoesHabilitados}>{this.state.orgao.id ? 'Alterar' : 'Incluir'}</button>
								}
								{this.state.orgao.id && 
									<Link to={`/organization/access/${this.state.orgao.id}`}> 
										<div className="back-button">
											<button type="button" className="button is-secondary" disabled={!this.state.botoesHabilitados}>Adesões</button>
										</div>
									</Link>
								}

								{this.state.orgao.id && 
									<button type="button" className="button is-secondary botaoNovo" onClick={this.novo} disabled={!this.state.botoesHabilitados}>Novo Órgão</button>
								}

								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>

					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const orgao = this.state.orgao;
			orgao[nome] = valor;
			this.setState({ orgao });
		}

		novo(e){
			const rotaParaNovo = "/organization/new";
			if (rotaParaNovo === this.props.location.pathname) {
				this.props.history.push("/");
				this.props.history.goBack();
			} else {
				this.props.history.push(rotaParaNovo);
			}
		}

		salvar(e){
			this.props.limpaMensagem();

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			this.setState({botoesHabilitados:false});
			const orgao = this.state.orgao;
			const method = orgao.id ? 'put' : 'post';
			let url = "/api/orgao";
			if(orgao.id){
				url = url + '/' + orgao.id;
			}
			const options = {
				method,
				url,
				"data" : {
					...orgao,
					esferaAdministrativa: orgao.esferaAdministrativa === "" ? null : orgao.esferaAdministrativa
				},
			}

			api(options)
				.then(response => {
					const mensagem = `Órgão ${this.state.orgao.id ? 'alterado' : 'incluído'} com sucesso!`;
					this.setState({ 
						orgao: response.data ,
					});
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = `Não foi possível ${this.state.orgao.id ? 'alterar' : 'incluir'} o órgão.`;
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);

				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
				});   
		}

		validaFormulario(){
			let mensagens = [];
			const {cnpj, nome, sigla, naturezaJuridica, esferaAdministrativa, uf } = this.state.orgao;
			
			if(!cnpj || cnpj.trim().length === 0 ){
				mensagens.push({mensagem: "CNPJ é obrigatório."})
			}

			if(!nome || nome.trim().length === 0 ){
				mensagens.push({mensagem: "Nome é obrigatório."})
			}

			if(!sigla || sigla.trim().length === 0 ){
				mensagens.push({mensagem: "Sigla é obrigatória."})
			}

			if(!naturezaJuridica){
				mensagens.push({mensagem: "Natureza Jurídica é obrigatória."})
			}

			if(!esferaAdministrativa){
				mensagens.push({mensagem: "Esfera Administrativa é obrigatória."})
			}

			if(!uf || !uf.trim().length === 0 ){
				mensagens.push({mensagem: "Unidade da Federação é obrigatória."})
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		pesquisarDadosEmpresariaisBasicos(){
			this.props.limpaMensagem();
			this.setState({botoesHabilitados: false})
			const cnpjInformado = this.state.orgao.cnpj;
			if(!isCNPJ(cnpjInformado)){
				this.props.exibeMensagemErro("Informe um CNPJ válido.")
				this.setState({botoesHabilitados: true})
			}else{
				this.props.mostraAguardando();
				api.get(`/api/orgao/dados_empresariais/${cnpjInformado}`)
				.then(response => { 
					if(this.state.naturezasJuridicas.some(naturezaJuridica => naturezaJuridica.id === Number(response.data?.naturezaJuridica?.codigo))) {
						this.atualizaOrgao(response.data);
						this.setState({executouPesquisaCNPJ: true}, () => {
							this.checkEsferaAdministrativa();
						});
					}else{
						this.setState({executouPesquisaCNPJ: false});
						this.props.exibeMensagemErro("Natureza jurídica do órgão inválida: " + response.data?.naturezaJuridica?.descricao)
					}	
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os dados empresariais do CNPJ informado ", erro)
					this.props.exibeMensagemErro("Não foi possível recuperar o nome do órgão: " + erro['data']['mensagem'])
				})
				.finally(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados: true});
				});
			}
		}

		checkEsferaAdministrativa() {
			const orgao = this.state.orgao;
			const {naturezaJuridica} = this.state.orgao;
			const naturezaJuridicaComEsfera = this.state.naturezasJuridicas.find(nj => nj.id === Number(naturezaJuridica));

			if (naturezaJuridicaComEsfera.esferaAdministrativa !== null) {
				this.setState({
					...this.state,
					hasEsferaAdministrativa: true,
				});
				orgao['esferaAdministrativa'] = naturezaJuridicaComEsfera.esferaAdministrativa;
			} else {
				this.setState({
					...this.state,
					hasEsferaAdministrativa: false,
				});
			 	orgao['esferaAdministrativa'] = this.props.match.params.id ? orgao.esferaAdministrativa : "";
			}
		}

		atualizaOrgao(dadosEmpresariais){
			const {nomeEmpresarial, naturezaJuridica, endereco, municipio} = dadosEmpresariais;
			const orgao = this.state.orgao;
			orgao['nome'] = nomeEmpresarial;
			orgao['naturezaJuridica'] = naturezaJuridica.codigo;
			orgao['nomeNaturezaJuridica'] = naturezaJuridica.descricao;
			orgao['codigoMunicipioIBGE'] = municipio.codigo;
			orgao['nomeMunicipioIBGE'] = municipio.descricao;

			this.checkEsferaAdministrativa();

			orgao['uf'] = endereco.uf;
			this.setState({orgao});
		}

		getCodigoIBGE(codigoMunicipioIBGE){
			const orgao = this.state.orgao;
			const esferaAdministrativa = orgao.esferaAdministrativa;

			if((! codigoMunicipioIBGE )|| (esferaAdministrativa !== 'E' && esferaAdministrativa !== 'M')){ 
				return "";
			} else if(esferaAdministrativa === 'E'){
				return codigoMunicipioIBGE.substring(0, 2);
			} else if(esferaAdministrativa === 'M'){
				return codigoMunicipioIBGE;
			} else {
				return "";
			}
		}

	}

) // redux
); // router